import React, { useEffect, useState } from "react";
import Select from "react-select";
import Loader from "../general/Loader";
import { postRequest, request } from "../../utils/request";
import { modalidadAusenciaForDropdown, money, toast } from "../../utils/helpers";
import dayjs from "dayjs";

const tiempoTrabajando = (ingreso) => {
    const start = dayjs(ingreso);
    const end = dayjs();

    const years = end.diff(start, "year");
    const months = end.diff(start.add(years, "year"), "month");

    return `${years} años y ${months} meses`;
};

const FormGroup = ({filtersQuery, cancel, success}) => {
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(0);
    const [saving, setSaving] = useState(false);

    const [pendientes, setPendientes] = useState([]);
    const [modalidad, setModalidad] = useState();
    const [contarSabado, setContarSabado] = useState(0);
    const [montosPagar, setMontosPagar] = useState({}); 

    const getPendientes = async () => {
        setLoading((state) => state + 1);

        const response = await request(`ausencias${filtersQuery}&limit=100000&clasificacion=vacaciones&estado=Pendiente`);

        setPendientes(response.data);

        setLoading((state) => state - 1);
    };

    const contar_sabado = (val) => {
        if (val === contarSabado) {
            setContarSabado(0);
        } else {
            setContarSabado(val);
        }
    }

    const changeMontoPagar = (id, monto) => {
        setMontosPagar({
            ...montosPagar,
            [id]: monto,
        });
    };

    const calcularMonto = (empleado, cantidad_dia) => {
        const sueldoDia = parseFloat(empleado.sueldoFijo) / 23.83;

        return parseFloat(money(montosPagar[empleado.id] ?? (sueldoDia * cantidad_dia)));
    };

    const crear = async (e) => {
        e.preventDefault();

        setSaving(true);

        const form = new FormData(e.target);
        const response = await postRequest(`ausencias/crear-vacaciones-colectivas`, form);

        if (response.success) {
            toast(response.data.message);
            success();
        }
        else toast("Error creando las vacaciones colectivas", "error");
        
        setSaving(false);
    };

    useEffect(() => {
        getPendientes();
    }, []);

    return <form onSubmit={crear}>
            <div className='popup__header'>Crear Vacaciones Colectivas</div>

            <div className='popup__body'>
                {loading ? <Loader /> : <div className="container">
                    <div className='row form-group'>
                        <div className='col col-md-5'>
                            <label className='label form-control-label'>Modalidad*:</label>
                        </div>
                        <div className='col col-md-7'>
                            <Select
                                name='modalidad'
                                key='modalidad'
                                isClearable={true}
                                value={modalidad}
                                onChange={(e) => {
                                    setModalidad(e);
                                }}
                                options={modalidadAusenciaForDropdown}
                            />
                            {errors.modalidad && (
                                <small className='help-blockParams form-Text'>
                                    {errors.modalidad[0]}
                                </small>
                            )}
                        </div>
                    </div>

                     <div className='row form-group'>
                        <div className='col col-md-5'>
                            <label className='label form-control-label'>Fecha de inicio*:</label>
                        </div>
                        <div className='col col-md-7'>
                            <input
                                type="date"
                                name="fecha"
                                className="form-control"
                            />
                            {errors.fecha && (
                                <small className='help-blockParams form-Text'>
                                    {errors.fecha[0]}
                                </small>
                            )}
                        </div>
                    </div>

                    <div className='row form-group'>
                        <input type='hidden' name='contar_sabado' value={contarSabado} />

                        <div className='col col-md-12'>
                            <div className="row m-0">
                                <label className='switch switch-3d switch-success mr-3'>
                                    <input
                                        type='checkbox'
                                        className='switch-input'
                                        name='contar_sabado_check'
                                        value='1'
                                        checked={contarSabado === 1}
                                        onChange={(e) => contar_sabado(1)}
                                    />
                                    <span className='switch-label' />
                                    <span className='switch-handle' />
                                </label>

                                <label className='label font-weight-bold form-control-label'>Considerar sábados como 1 día laborable</label>
                            </div>

                            {errors.contar_sabado && (
                                <small className='help-blockParams form-Text'>
                                    {errors.contar_sabado[0]}
                                </small>
                            )}
                        </div>

                        <div className='col col-md-12'>
                            <div className="row m-0">
                                <label className='switch switch-3d switch-success mr-3'>
                                    <input
                                        type='checkbox'
                                        className='switch-input'
                                        name='contar_sabado_check'
                                        value='0.5'
                                        checked={contarSabado === 0.5}
                                        onChange={(e) => contar_sabado(0.5)}
                                    />
                                    <span className='switch-label' />
                                    <span className='switch-handle' />
                                </label>

                                <label className='label font-weight-bold form-control-label'>Considerar sábados como 1/2 día laborable</label>
                            </div>
                            {errors.contar_sabado && (
                                <small className='help-blockParams form-Text'>
                                    {errors.contar_sabado[0]}
                                </small>
                            )}
                        </div>
                    </div>

                    <div className='row form-group'>
                        <div className='col col-md-5'>
                            <label className='label form-control-label'>Descripción*:</label>
                        </div>
                        <div className='col col-md-7'>
                            <textarea
                                type='text'
                                className='text-input form-control'
                                name='descripcion'
                            />
                            {errors.descripcion && (
                                <small className='help-blockParams form-Text'>
                                    {errors.descripcion[0]}
                                </small>
                            )}
                        </div>
                    </div>

                    <div className='row'>
                        <h3 className="col-12"><strong>Empleados - {pendientes.length}</strong></h3>
                        <div className="col"><strong>Nombre</strong></div>
                        <div className="col"><strong>Tiempo trabajando</strong></div>
                        <div className="col-3"><strong>Días disponibles</strong></div>
                        {(modalidad?.value === "normal_pagas" || modalidad?.value === "trabajadas_normal_pagas") && <div className="col-4"><strong>Monto a Pagar<strong/></strong></div>}
                    </div>

                    {pendientes.map((pendiente, index) => <div className="row form-group" key={pendiente.id}>
                        <div className="col">
                            <input
                                name={`empleados[${index}][id]`}
                                type="hidden"
                                value={pendiente.empleado.id}
                            />
                            {pendiente.empleado.nombreCompleto}
                        </div>
                        <div className="col">{tiempoTrabajando(pendiente.empleado.fechaIngreso)}</div>
                        <div className="col-3">
                            <input
                                name={`empleados[${index}][cantidad_dia]`}
                                type="hidden"
                                value={pendiente.restantes}
                            />
                            {pendiente.restantes}
                        </div>
                        {(modalidad?.value === "normal_pagas" || modalidad?.value === "trabajadas_normal_pagas") ? <div className="col-4">
                            <input
                                name={`empleados[${index}][monto_pagar]`}
                                type="number"
                                step={0.01}
                                style={{ backgroundColor: "#fff" }}
                                value={calcularMonto(pendiente.empleado, pendiente.restantes)}
                                onChange={(e) => changeMontoPagar(pendiente.empleado.id, e.target.value)}
                                className="form-control"
                            />
                        </div> : <input type="hidden" name={`empleados[${index}][monto_pagar]`} value={0}/>}
                    </div>)}
                </div> }
            </div>

            { saving
                ? <Loader />
                : (<div className='popup__footer'>
                    <div className="row">
                        <button
                            type='button'
                            onClick={cancel}
                            className="btn btn-plain mr-auto ml-2">
                            Cancelar
                        </button>
                        
                        {!loading && <button type='submit' className='btn btn-primary mr-2'>
                            Crear
                        </button>}
                    </div>
                </div>)
            }
        </form>;
};

export default FormGroup;